<template>
  <section>
    <form-spinner v-if="loading" class="spinner"/>
    <main>
      <logo fill="#444" class="logo" />
      <div class="main" v-if="pedido">
        <template v-if="pedido.datasaida">
          <header>
            <h4>Pedido {{ pedido.idpedidomaterial }}</h4>
          </header>
          <div>
            <p>{{ pedido.descricao }}</p>
            <h2>Este pedido já foi entregue.</h2>
          </div>
        </template>
        <template v-else>
          <header>
            <h4>Entregar Pedido {{ pedido.idpedidomaterial }}</h4>
            <p>Data prevista de entrega: {{ pedido.entregaprevista }}</p>
          </header>
          <span v-if="!done" :class="['status', getStatus().slug]" v-html="dropMsg(getStatus())"></span>
          <div v-if="ready">
            <template v-if="done">
              <h2>Pedido entregue com sucesso!</h2>
              <p>Você pode fechar essa página.</p>
            </template>
            <h2 v-else>Tem certeza que deseja entregar o pedido {{ pedido.codigo }} do(a) aluno(a) {{ pedido.aluno }}, com {{pedido.contagem_itens}} {{ (pedido.contagem_itens == 1 ) ? 'item' : 'itens' }}?</h2>
          </div>
          <div>
            <swipe-button label="Entregar" sucesso="Entregue" @confirm="deliver()"/>
          </div>
        </template>
      </div>
    </main>
    
  </section>
</template>

<script>
import MarketplaceService from '@/services/marketplace.service.js'
import FormSpinner from '@/components/utilities/FormSpinner.vue'
import Logo from '@/components/loja/template/Logo.vue'
import SwipeButton from '@/components/utilities/SwipeButton.vue'
import moment from 'moment'

export default {
  components: {
    FormSpinner, Logo, SwipeButton
  },
  props: {
    idPedido: [String, Number]
  },
  data () {
    return {
      loading: false,
      ready: false,
      pedido: null,
      done: false,
    }
  },  
  mounted () {
    this.getPedido()
  },
  methods: {
    getStatus () {
      const today = moment()
      const entregaPrevista = moment(this.pedido.entregaprevista,"DD/MM/YYYY",)
      var diff = today.diff(entregaPrevista,'days')


      let status = 'na data'
      let slug = 'na_data'
      if ( diff > 0 )  {
        status = 'depois'
        slug = 'atrasado'
      }
      if ( diff < 0 ) {
        status = 'antes'
        slug = 'adiantado'
      }

      return {
        status, diff, slug
      }
    },
    dropMsg ( props ) {
      const prefix = 'Você está entregando esse pedido '
      const diff = props.diff < 0 ? props.diff *(-1) : props.diff
      const custom = props.diff == 0 ? props.status : `<b>${diff} dias ${ props.status } do prazo.</b>`
      const msg = prefix + custom

      return msg
    },
    getPedido () {
      this.loading = true
      MarketplaceService.getPedido(this.idPedido)
      .then( response => {
        this.pedido = response.data
        console.log("pedido:", response.data)
        this.pedido['codigo'] = this.pedido.descricao.split(" - ")[0]
        this.pedido['aluno'] = this.pedido.descricao.split(" - ")[1]
        
        this.ready = true
        console.log("pedido:", this.pedido)
      })
      .catch( error => {
        console.error(error)
      })
      .finally(() => {
        this.loading = false
      })
    },
    deliver () {
      this.loading = true
      MarketplaceService.retiradoUnidade([this.idPedido])
      .then(() => {
        this.done = true
      })
      .catch( error => {
        console.error(error)
        window.toaster.emit('open', {
          style: 'warning',
          message: error.response?.data?.message || 'Não foi possível entregar o pedido.',
          floater: true
        })
      })
      .finally(() => {
        setTimeout(() => {
          this.loading = false
        },2000)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .spinner {
    margin: 0; padding: 0;
  }
  
  section {
    background-color: $color-bg;
    
    main {
      padding: $hmg_mid;

      .logo {
        margin: 0 auto $hmg_mid;
      }
      .main {
        border-radius: $border-radius;
        border: $border-component;
        
        background-color: $color-secondary;
        text-align: center;
        max-width: 440px;
        margin: auto;

        header {
          border-bottom: $border-component;
          padding: $hmg_mid;
          text-align: center;

          h4 {
            margin: 0; padding: 0;
          }
          p {
            margin: 0; padding: 0;
          }
        }
        
        .status {
          display: block;
          width: 100%;
          padding: $mg_mini;
          border-bottom: $border-component;

          &.na_data { background-color: $color-bg; }
          &.adiantado { background-color: $color-success; color: $color-secondary}
          &.atrasado { background-color: $color-alert; color: $color-secondary}
        }

        >div {
          padding: $hmg_mid;
        }
    }
    
    }

    .button {
      display: block;
      width: 100%;
      height: auto;
      padding: $hmg_mid;
      text-align: center;
      background-color: $color-success;
      font-size: 2rem;
      border-radius: $border-radius-small;
      margin-top: $hmg_mid;
      color: $color-secondary; font-weight: bold;
    }
  }
</style>
